import Logger from '../Logger/Logger';
import CookieStorage from './StorageTargets/CookieStorage';
import PermanentStorage from './StorageTargets/LocalStorage';
import TemporaryStorage from './StorageTargets/SessionStorage';
import {
  StorageType,
  StorageConfigInterface,
  StorageInterface,
  StorageInstancesInterface,
  StorageServiceInterface,
} from './types/storageTypes';

const StorageService = (function (root, factory) {
  let storageService: StorageServiceInterface = {} as StorageServiceInterface;
  const loggerServiceInstance = Logger.getInstance();
  if (root) {
    if (root.storageService) {
      ({ storageService } = root);
      loggerServiceInstance.log('Storage Service already loaded, using existing version');
    } else {
      root.storageService = storageService;
      return factory(storageService);
    }
  }
  return storageService;
})(
  (typeof window === 'object' && window) || (typeof globalThis === 'object' && globalThis) || this,
  function (storageService: StorageServiceInterface) {
    const config: StorageConfigInterface = {
      [StorageType.PERMANENT]: { encryption: true },
      [StorageType.TEMPORARY]: { encryption: true },
      [StorageType.COOKIE]: {},
    };

    const storageInstances: StorageInstancesInterface = {
      [StorageType.PERMANENT]: new PermanentStorage({
        ...config[StorageType.PERMANENT],
      }),
      [StorageType.TEMPORARY]: new TemporaryStorage({
        ...config[StorageType.TEMPORARY],
      }),
      [StorageType.COOKIE]: new CookieStorage({
        ...config[StorageType.COOKIE],
      }),
    };

    // /**
    //  * Returns instance of storage provided. Defaults, it will return StorageType.PERMANENT
    //  * @param {StorageType} storageType type of the Storage
    //  */

    storageService.getStorage = (storageType: StorageType = StorageType.PERMANENT): StorageInterface =>
      storageInstances[storageType] as StorageInterface;
    /**
     * Returns instance of localStorage
     */

    storageService.getLocalStorage = (): StorageInterface =>
      storageInstances[StorageType.PERMANENT] as StorageInterface;
    /**
     * Returns instance of sessionStorage
     */

    storageService.getSessionStorage = (): StorageInterface =>
      storageInstances[StorageType.TEMPORARY] as StorageInterface;
    /**
     * Returns instance of cookieStorage
     */

    storageService.getCookieStorage = (): StorageInterface => storageInstances[StorageType.COOKIE] as StorageInterface;
    /**
     * Set Configuration for Storage
     */
    storageService.setConfig = (configurations: StorageConfigInterface) => {
      for (const key in configurations) {
        if (Object.prototype.hasOwnProperty.call(configurations, key)) {
          if (key === StorageType.PERMANENT) {
            storageInstances[key] = new PermanentStorage({
              ...configurations[key],
            });
          }
          if (key === StorageType.TEMPORARY) {
            storageInstances[key] = new TemporaryStorage({
              ...configurations[key],
            });
          }
          if (key === StorageType.COOKIE) {
            storageInstances[key] = new CookieStorage({
              ...configurations[key],
            });
          }
        }
      }
    };
    return storageService;
  },
);

export default StorageService;
